import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';

import { Section, SectionTitle } from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import styles from './TrustpilotReviews.scss';

const TrustBox = ({ formattedLocale }) => {
    // Create a reference to the <div> element which will represent the TrustBox
    const ref = React.useRef(null);

    useEffect(() => {
        // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
        // If it's not, it means the script in the <head /> isn't loaded  just yet.
        // When it is, it will automatically load the TrustBox.
        if (window.Trustpilot && ref?.current) {
            window.Trustpilot.loadFromElement(ref.current, true);
        }
    }, []);

    return (
        <div
            className="trustpilot-widget"
            data-businessunit-id="54a40c7700006400057c6e53" data-locale={formattedLocale} data-style-height="100%" data-style-width="100%" data-template-id="5613c9cde69ddc09340c6beb" data-testid="trustpilot-widget" data-theme="light"
            ref={ref} // We need a reference to this element to load the TrustBox in the effect.
        />
    );
};

TrustBox.propTypes = {
    formattedLocale: PropTypes.string,
};

const propTypes = {
    locale: PropTypes.string,
    t: PropTypes.func,
};

function TrustpilotReviews(props) {
    const {
        locale,
        t,
    } = props;
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    const [language, location] = locale.split('-');
    const formattedLocale = [language, location.toUpperCase()].join('-');

    return (
        <Section className={styles.section} color="light" id="trustpilot-reviews-section">
            <SectionTitle className={styles.title}>
                {t('trustpilot-header')}
            </SectionTitle>
            {isClient && <TrustBox formattedLocale={formattedLocale} />}
        </Section>
    );
}

TrustpilotReviews.propTypes = propTypes;

export default localize(TrustpilotReviews, 'baseApp');
